export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Please input your phone',
  'pages.login.username.required': 'Please input your phone!',
  'pages.login.password.placeholder': 'Please input your password!',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',

  // Carousel (Operating)
  'pages.carousel.id': 'ID',
  'pages.carousel.name': 'Name',
  'pages.carousel.image': 'Image',
  'pages.carousel.position': 'Position',
  'pages.carousel.linkType': 'Link Type',
  'pages.carousel.linkUrl': 'Link URL',
  'pages.carousel.target': 'Target Param',
  'pages.carousel.sort': 'Sort',
  'pages.carousel.status': 'Status',
  'pages.carousel.create': 'Create Banner',
  'pages.carousel.edit': 'Edit Banner',
  'pages.carousel.name.required': 'Please enter name',
  'pages.carousel.enable.confirm': 'Enable this banner?',
  'pages.carousel.disable.confirm': 'Disable this banner?',
  'pages.carousel.delete.confirm': 'Delete this banner?',
  // Commons
  'pages.common.new': 'New',
  'pages.common.enable': 'Enable',
  'pages.common.disable': 'Disable',
  'pages.common.delete': 'Delete',
  'pages.common.act': 'Actions',
  'pages.common.actions': 'Actions',
  'pages.common.success': 'Success',
  'pages.common.deleted': 'Deleted',
  'pages.common.saveSuccess': 'Saved',
  // ImageCropUpload component
  'pages.common.empty': 'No image',
  'pages.common.upload': 'Crop and Upload',
  // Notice (Announcement)
  'pages.notice.title': 'Title',
  'pages.notice.content': 'Content',
  'pages.notice.status': 'Status',
  'pages.notice.sort': 'Sort',
  'pages.notice.timeRange': 'Time Range',
  'pages.notice.relList': 'Related Goods',
  'pages.notice.mobilePosition': 'Mobile Display Position',
  'pages.notice.mobilePosition.home': 'Home',
  'pages.notice.mobilePosition.goods': 'Goods Detail',
  'pages.notice.mobilePosition.order': 'Order List',
  'pages.notice.createNotice': 'Create Notice',
  'pages.notice.detail': 'Detail',
  'pages.notice.publish': 'Publish',
  'pages.notice.terminate': 'Terminate',
  'pages.notice.published': 'Published',
  'pages.notice.unpublished': 'Unpublished',
  // Recommendation
  'pages.recommendation.create': 'Create Recommendation',
  'pages.recommendation.edit': 'Edit Recommendation',
  'pages.recommendation.enable.confirm': 'Enable this recommendation?',
  'pages.recommendation.disable.confirm': 'Disable this recommendation?',
  'pages.recommendation.delete.confirm': 'Delete this recommendation?',
  'pages.recommendation.sort': 'Sort',
  'pages.recommendation.timeRange': 'Time Range',
  'pages.recommendation.goodsName': 'Goods Name',
  'pages.recommendation.goodsNameInput': 'Please select a good',
  'pages.recommendation.editBtn': 'edit',
  // System Dept
  'pages.system.dept.disable.confirm': 'Disable this department?',
  'pages.system.dept.enable.confirm': 'Enable this department?',
  'pages.system.dept.delete.confirm': 'Are you sure to delete this department?',
  'pages.common.deleteFailed': 'Delete failed',
  'pages.common.saveFailed': 'Save failed',
  'pages.common.cancel': 'Cancel',
  'pages.common.confirm': 'Confirm',
  'pages.common.enabled': 'Enabled',
  'pages.common.disabled': 'Disabled',
  'pages.common.pagination.total': '{start}-{end} of {total} items',
  'pages.common.createTime': 'Create Time',
  'pages.common.updateTime': 'Update Time',
  'pages.notice.create': 'Create Notice',
  'pages.notice.edit': 'Edit Notice',
  'pages.notice.enable.confirm': 'Enable this notice?',
  'pages.notice.disable.confirm': 'Disable this notice?',
  'pages.notice.delete.confirm': 'Delete this notice?',
  'pages.notice.title.required': 'Please enter title',
  'pages.notice.content.required': 'Please enter content',
  'pages.notice.sortOrder': 'Sort Order',
  'pages.notice.isActive': 'Is Active',
  'pages.notice.active': 'Yes',
  'pages.notice.inactive': 'No',
  'pages.notice.terminate.confirm': 'Are you sure to terminate this notice?',
  'pages.notice.publish.confirm': 'Are you sure to publish this notice?',
  'pages.notice.showStartTime': 'Start Time',
  'pages.notice.showEndTime': 'End Time',
  // System Menu
  'pages.system.menu.create': 'Create Menu',
  'pages.system.menu.edit': 'Edit Menu',
  'pages.system.menu.name': 'Menu Name',
  'pages.system.menu.name.required': 'Please enter menu name',
  'pages.system.menu.type': 'Type',
  'pages.system.menu.code': 'Code',
  'pages.system.menu.code.required': 'Please enter code',
  'pages.system.menu.type.catalog': 'Catalog',
  'pages.system.menu.type.menu': 'Menu',
  'pages.system.menu.type.button': 'Button',
  'pages.system.menu.parent': 'Parent Menu',
  'pages.system.menu.path': 'Route',
  'pages.system.menu.component': 'Component Path',
  'pages.system.menu.icon': 'Icon',
  'pages.system.menu.order': 'Order',
  'pages.system.menu.import': 'Import Menu',
  'pages.system.menu.downloadTemplate': 'Download Template',
  'pages.system.menu.template.filename': 'Menu Import Template',
  'pages.system.menu.template.download.success':
    'Template downloaded successfully',
  'pages.system.menu.template.download.error':
    'Failed to download template, please try again',
  'pages.system.menu.import.button': 'Import Menu',
  'pages.system.menu.import.success': 'Menu imported successfully',
  'pages.system.menu.import.error.fileType': 'You can only upload Excel files!',
  'pages.system.menu.import.error.fileSize': 'File must be smaller than 10MB!',
  'pages.system.menu.import.error.import': 'Failed to import menu',
  'pages.system.menu.import.error.network':
    'Failed to import menu, please check network connection',
  'pages.system.menu.currentVersion': 'Current Version ID: {versionId}',
  'pages.system.menu.disable.confirm': 'Disable this menu?',
  'pages.system.menu.enable.confirm': 'Enable this menu?',
  'pages.system.menu.maxLevel': 'Maximum level is 3',
  'pages.system.menu.menu.requires': 'Menu requires route and component path',
  'pages.system.menu.redirect': 'Redirect',
  'pages.system.menu.button.create': 'Create Button',
  'pages.system.menu.button.edit': 'Edit Button',
  'pages.system.menu.button.name': 'Button Name',
  'pages.system.menu.button.name.required': 'Please enter button name',
  'pages.system.menu.button.code': 'Code',
  'pages.system.menu.button.code.required': 'Please enter code',
  'pages.system.menu.button.uiType': 'Button UI Type',
  'pages.system.menu.button.uiType.placeholder': 'Please select button UI type',
  'pages.system.menu.button.placement': 'Button Placement',
  'pages.system.menu.button.placement.placeholder':
    'Please select button placement',
  'pages.system.menu.button.placement.required':
    'Please select button placement',
  'pages.system.menu.isHidden': 'Hidden',
  'pages.system.menu.isHidden.no': 'Show',
  'pages.system.menu.isHidden.yes': 'Hide',
  'pages.system.menu.description': 'Description',
  'pages.system.menu.sortOrder': 'Order',
  'pages.system.menu.addMenu': 'Add Menu',
  'pages.system.menu.buttonManagement': 'Button Management',
  'pages.system.menu.module': 'Module',
  'pages.system.menu.menu': 'Menu',
  'pages.system.menu.button': 'Button',
  'pages.system.menu.disable.confirm.title': 'Disable this {type}?',
  'pages.system.menu.disable.confirm.content': 'This {type} will be disabled',
  'pages.system.menu.enable.confirm.title': 'Enable this {type}?',
  'pages.system.menu.enable.confirm.content': 'This {type} will be enabled',
  'pages.system.menu.delete.confirm.title': 'Delete this {type}?',
  'pages.system.menu.delete.confirm.content':
    'This {type} will be permanently deleted',

  // Permission Version Management
  'pages.system.permissionVersion.title': 'Version Management',
  'pages.system.permissionVersion.create': 'Add Version',
  'pages.system.permissionVersion.edit': 'Edit Version',
  'pages.system.permissionVersion.versionName': 'Version Name',
  'pages.system.permissionVersion.versionName.placeholder':
    'Please enter version name',
  'pages.system.permissionVersion.versionName.required':
    'Please enter version name',
  'pages.system.permissionVersion.versionName.maxLength':
    'Version name cannot exceed 50 characters',
  'pages.system.permissionVersion.versionCode': 'Version Code',
  'pages.system.permissionVersion.versionCode.placeholder':
    'Please enter version code',
  'pages.system.permissionVersion.versionCode.required':
    'Please enter version code',
  'pages.system.permissionVersion.status': 'Status',
  'pages.system.permissionVersion.status.required': 'Please select status',
  'pages.system.permissionVersion.create.success': 'Created successfully',
  'pages.system.permissionVersion.create.error': 'Failed to create',
  'pages.system.permissionVersion.update.success': 'Updated successfully',
  'pages.system.permissionVersion.update.error': 'Failed to update',
  'pages.system.permissionVersion.save.error':
    'Failed to save, please try again',
  'pages.system.permissionVersion.delete.success': 'Deleted successfully',
  'pages.system.permissionVersion.delete.error': 'Failed to delete',
  'pages.system.permissionVersion.delete.confirm.title': 'Delete Confirmation',
  'pages.system.permissionVersion.delete.confirm.content':
    'Are you sure you want to delete version "{name}"? This operation cannot be undone.',
  'pages.system.permissionVersion.status.update.success':
    'Status updated successfully',
  'pages.system.permissionVersion.status.update.error':
    'Failed to update status',
  'pages.system.permissionVersion.list.error': 'Failed to get list',
  'pages.system.permissionVersion.enable.confirm':
    'Are you sure to enable this version?',
  'pages.system.permissionVersion.disable.confirm':
    'Are you sure to disable this version?',
  'pages.system.permissionVersion.menuManagement': 'Menu Management',

  // Role management related
  'pages.role.edit': 'Edit Role',
  'pages.role.create': 'Create Role',
  'pages.role.name': 'Role Name',
  'pages.role.code': 'Role Code',
  'pages.role.remark': 'Remark',
  'pages.role.status': 'Status',
  'pages.role.systemRole': 'System Role',
  'pages.role.management': 'Role Management',
  'pages.role.permissionConfig': 'Permission Config',
  'pages.role.enable': 'Enable',
  'pages.role.disable': 'Disable',
  'pages.role.enable.confirm': 'Enable this role?',
  'pages.role.disable.confirm': 'Disable this role?',
  'pages.role.delete.confirm': 'Delete this role?',
  'pages.role.delete.content':
    'This action cannot be undone, please proceed with caution',
  'pages.role.name.required': 'Please enter role name',
  'pages.role.name.maxLength': 'Role name cannot exceed 50 characters',
  'pages.role.name.placeholder': 'Please enter role name',
  'pages.role.code.required': 'Please enter role code',
  'pages.role.code.pattern':
    'Role code can only contain letters, numbers and underscores',
  'pages.role.code.maxLength': 'Role code cannot exceed 50 characters',
  'pages.role.code.placeholder': 'Please enter role code',
  'pages.role.remark.placeholder': 'Please enter remark',
  'pages.role.status.enabled': 'Enabled',
  'pages.role.status.disabled': 'Disabled',
  'pages.role.systemRole.yes': 'Yes',
  'pages.role.systemRole.no': 'No',
  'pages.role.fetchDept.failed': 'Failed to fetch department data',
  'pages.role.fetchDept.networkError':
    'Failed to fetch department data, please check network connection',

  // Staff management related
  'pages.staff.edit': 'Edit Staff',
  'pages.staff.create': 'Create Staff',
  'pages.staff.name': 'Staff Name',
  'pages.staff.phone': 'Phone',
  'pages.staff.password': 'Password',
  'pages.staff.role': 'Role',
  'pages.staff.status': 'Status',
  'pages.staff.management': 'Staff Management',
  'pages.staff.deptStructure': 'Department List',
  'pages.staff.passwordManagement': 'Password Management',
  'pages.staff.delete.confirm': 'Confirm Delete',
  'pages.staff.delete.content':
    'Are you sure to delete staff "{name}"? This action cannot be undone.',
  'pages.staff.delete.success': 'Deleted successfully',
  'pages.staff.delete.failed': 'Delete failed',
  'pages.staff.fetchDetail.failed': 'Failed to fetch staff details',
  'pages.staff.fetchDept.failed': 'Failed to fetch department data',
  'pages.staff.fetchDept.networkError':
    'Failed to fetch department data, please check network connection',
  'pages.staff.fetchRole.failed': 'Failed to fetch role list',
  'pages.staff.name.required': 'Please enter staff name',
  'pages.staff.name.placeholder': 'Please enter staff name',
  'pages.staff.name.maxLength': 'Staff name cannot exceed 50 characters',
  'pages.staff.phone.required': 'Please enter phone number',
  'pages.staff.phone.placeholder': 'Please enter phone number',
  'pages.staff.phone.invalid': 'Please enter a valid phone number',
  'pages.staff.password.required': 'Please enter password',
  'pages.staff.password.placeholder': 'Please enter password',
  'pages.staff.password.noModify': 'Leave blank if no changes',
  'pages.staff.password.minLength': 'Password must be at least 6 characters',
  'pages.staff.role.placeholder': 'Please select a role',
  'pages.staff.status.normal': 'Normal',
  'pages.staff.status.disabled': 'Disabled',
  'pages.staff.password.change': 'Change Password',
  'pages.staff.password.new': 'New Password',
  'pages.staff.password.new.required': 'Please enter new password',
  'pages.staff.password.new.placeholder': 'Please enter new password',
  'pages.staff.password.new.minLength':
    'Password must be at least 6 characters',
  'pages.staff.password.new.maxLength': 'Password cannot exceed 20 characters',
  'pages.staff.password.confirm': 'Confirm Password',
  'pages.staff.password.confirm.required': 'Please confirm new password',
  'pages.staff.password.confirm.placeholder': 'Please enter new password again',
  'pages.staff.password.confirm.mismatch': 'The two passwords do not match',
  'pages.staff.password.update.success': 'Password updated successfully',
  'pages.staff.password.update.failed': 'Password update failed',
  'pages.staff.info.incomplete': 'Staff information is incomplete',
  'pages.staff.unknownError': 'Unknown error',
  'pages-pool-member.staff.deptList': 'Department List',

  /** pages-pool-member goods (aligned with zh-CN pages.goods) */
  'pages-pool-member.goods.name': 'Goods name',
  'pages-pool-member.goods.nameprice': 'Goods price',
  'pages-pool-member.goods.nameInput': 'Please enter goods name',
  'pages-pool-member.goods.title.basicInfo': 'Basic information',
  'pages-pool-member.goods.title.create': 'Create goods',
  'pages-pool-member.goods.title.edit': 'Edit goods',
  'pages-pool-member.goods.saleRange': 'Sales range',
  'pages-pool-member.goods.saleRange.child': 'Child pass',
  'pages-pool-member.goods.saleRange.adult': 'Adult pass',
  'pages-pool-member.goods.saleRange.elderly': 'Senior pass',
  'pages-pool-member.goods.goodsStatus': 'Goods status',
  'pages-pool-member.goods.goodsStatus.onself': 'On sale',
  'pages-pool-member.goods.goodsStatus.offself': 'Off shelf',
  'pages-pool-member.goods.goodsType': 'Goods type',
  'pages-pool-member.goods.goodsType.single': 'Single pass',
  'pages-pool-member.goods.goodsType.multiple': 'Multi pass',
  'pages-pool-member.goods.goodsType.circle': 'Period pass',
  'pages-pool-member.goods.goodsType.group': 'Bundle',
  'pages-pool-member.goods.goodsType.groupTeam': 'Bundle (group)',
  'pages-pool-member.goods.inventory': 'Stock',
  'pages-pool-member.goods.inventory.unit': 'pcs/day',
  'pages-pool-member.goods.useCount': 'Entitlements',
  'pages-pool-member.goods.validDate': 'Valid period',
  'pages-pool-member.goods.autoOffself': 'Off-shelf time',
  'pages-pool-member.goods.rightsDays': 'Entitlement days',
  'pages-pool-member.goods.rightsDays.unit': 'calendar days',
  'pages-pool-member.goods.selectGoods': 'Select goods',
  'pages-pool-member.goods.tags': 'Tags',
  'pages-pool-member.goods.picture': 'Intro images',
  'pages-pool-member.goods.rights': 'Goods benefits',
  'pages-pool-member.goods.description': 'Description',
  'pages-pool-member.goods.label.price': 'Price',
  'pages-pool-member.goods.price': 'Pricing',
  'pages-pool-member.goods.price.ageGroup': 'Age group',
  'pages-pool-member.goods.price.workerDay': 'Weekday',
  'pages-pool-member.goods.price.holiday': 'Holiday',
  'pages-pool-member.goods.title.useRule': 'Usage rules',
  'pages-pool-member.goods.verifyWay': 'Verification method',
  'pages-pool-member.goods.avaPool': 'Available pools',
  'pages-pool-member.goods.code': 'QR code',
  'pages-pool-member.goods.face': 'Face',
  'pages-pool-member.goods.manul': 'Manual (front desk)',
  'pages-pool-member.goods.title.otherInfo': 'Other information',
  'pages-pool-member.goods.serviceContent': 'Service content',
  'pages-pool-member.goods.beforeBuy': 'Before purchase',
  'pages-pool-member.goods.noticeItems': 'Notes',
  'pages-pool-member.goods.refundPolicy': 'Refund policy',

  /** pages-pool-member common */
  'pages-pool-member.common.act': 'Action',
  'pages-pool-member.common.actions': 'Actions',
  'pages-pool-member.common.edit': 'Edit',
  'pages-pool-member.common.delete': 'Delete',
  'pages-pool-member.common.delete-success': 'Deleted successfully',
  'pages-pool-member.common.create-success': 'Saved successfully',
  'pages-pool-member.common.create-failed': 'Save failed',
  'pages-pool-member.common.clickToUpload': 'Click to select image',
  'pages-pool-member.common.empty': 'Empty',
  'pages-pool-member.common.cancel': 'Cancel',
  'pages-pool-member.common.confirm': 'Confirm',
  'pages-pool-member.common.createTime': 'Created at',
  'pages-pool-member.common.success': 'Succeeded',
  'pages-pool-member.common.enabled': 'Enabled',
  'pages-pool-member.common.disabled': 'Disabled',
  'pages-pool-member.common.enable': 'Enable',
  'pages-pool-member.common.disable': 'Disable',
  'pages-pool-member.common.deleted': 'Deleted',
  'pages-pool-member.common.deleteFailed': 'Delete failed',
  'pages-pool-member.common.saveSuccess': 'Saved successfully',
  'pages-pool-member.common.saveFailed': 'Save failed',
  'pages-pool-member.common.new': 'New',
  'pages-pool-member.common.serial': 'No.',
  'pages-pool-member.404.subTitle':
    'Sorry, the page you visited does not exist.',
  'pages-pool-member.404.buttonText': 'Back Home',
  'pages-pool-member.system.menu.module': 'Module',
  'pages-pool-member.system.menu.menu': 'Menu',

  /** pages-pool-member gym protocol */
  'pages-pool-member.space.protocol.create': 'New agreement',
  'pages-pool-member.space.protocol.create-title': 'New agreement',
  'pages-pool-member.space.protocol.update-title': 'Edit agreement',
  'pages-pool-member.space.protocol.agreement-type': 'Agreement type',
  'pages-pool-member.space.protocol.agreement-type-placeholder':
    'Select agreement type',
  'pages-pool-member.space.protocol.agreement-type-required':
    'Please select agreement type',
  'pages-pool-member.space.protocol.user-agreement': 'User agreement',
  'pages-pool-member.space.protocol.privacy-agreement': 'Privacy policy',
  'pages-pool-member.space.protocol.refund-agreement': 'Refund policy',
  'pages-pool-member.space.protocol.goods-agreement': 'Goods agreement',
  'pages-pool-member.space.protocol.payment-agreement': 'Payment agreement',
  'pages-pool-member.space.protocol.agreement-version': 'Version',
  'pages-pool-member.space.protocol.agreement-version-placeholder':
    'Enter version',
  'pages-pool-member.space.protocol.agreement-version-required':
    'Please enter version',
  'pages-pool-member.space.protocol.is-effective': 'Effective',
  'pages-pool-member.space.protocol.is-effective-placeholder':
    'Select effective status',
  'pages-pool-member.space.protocol.is-effective-required':
    'Please select effective status',
  'pages-pool-member.space.protocol.valid': 'Active',
  'pages-pool-member.space.protocol.invalid': 'Inactive',
  'pages-pool-member.space.protocol.create-time': 'Created at',
  'pages-pool-member.space.protocol.create-user': 'Created by',
  'pages-pool-member.space.protocol.update-time': 'Updated at',
  'pages-pool-member.space.protocol.update-user': 'Updated by',
  'pages-pool-member.space.protocol.content': 'Content',
  'pages-pool-member.space.protocol.content-required': 'Please enter content',
  'pages-pool-member.space.protocol.delete-confirm': 'Delete this agreement?',

  /** pages-pool-member order list */
  'pages-pool-member.order.orderList.index.orderNumber': 'Order Number',
  'pages-pool-member.order.orderList.index.goodsType': 'Goods Type',
  'pages-pool-member.order.orderList.index.single': 'Single Pass',
  'pages-pool-member.order.orderList.index.package': 'Package Pass',
  'pages-pool-member.order.orderList.index.period': 'Period Pass',
  'pages-pool-member.order.orderList.index.relatedGoods': 'Related Goods',
  'pages-pool-member.order.orderList.index.orderDate': 'Order Date',
  'pages-pool-member.order.orderList.index.memberName': 'Member Name',
  'pages-pool-member.order.orderList.index.memberPhone': 'Member Phone',
  'pages-pool-member.order.orderList.index.orderStatus': 'Order Status',
  'pages-pool-member.order.orderList.index.amount': 'Order Amount',
  'pages-pool-member.order.orderList.index.paidAmount': 'Paid Amount',
  'pages-pool-member.order.orderList.index.paymentType': 'Payment Type',
  'pages-pool-member.order.orderList.index.paymentTime': 'Payment Time',
  'pages-pool-member.order.orderList.index.paymentStatus': 'Payment Status',
  'pages-pool-member.order.orderList.index.hasRefund': 'Has Refund',
  'pages-pool-member.order.orderList.index.yes': 'Yes',
  'pages-pool-member.order.orderList.index.no': 'No',
  'pages-pool-member.order.orderList.index.refundAmount': 'Refund Amount',
  'pages-pool-member.order.orderList.index.member': 'Member',
  'pages-pool-member.order.orderList.index.createTime': 'Create Time',
  'pages-pool-member.order.orderList.index.details': 'Details',
  'pages-pool-member.order.orderList.index.offlineRefund': 'Offline Refund',
  'pages-pool-member.order.orderList.index.exportDetails': 'Export Details',

  /** pages-pool-member order detail */
  'pages-pool-member.order.orderList.components.OrderInfo.orderDetails':
    'Order Details',
  'pages-pool-member.order.orderList.components.OrderInfo.basicInfo':
    'Basic Information',
  'pages-pool-member.order.orderList.components.OrderInfo.orderId': 'Order ID',
  'pages-pool-member.order.orderList.components.OrderInfo.orderNumber':
    'Order Number',
  'pages-pool-member.order.orderList.components.OrderInfo.payOrderId':
    'Payment Order ID',
  'pages-pool-member.order.orderList.components.OrderInfo.goodsCount':
    'Goods Count',
  'pages-pool-member.order.orderList.components.OrderInfo.orderAmount':
    'Order Amount',
  'pages-pool-member.order.orderList.components.OrderInfo.orderStatus':
    'Order Status',
  'pages-pool-member.order.orderList.components.OrderInfo.paymentStatus':
    'Payment Status',
  'pages-pool-member.order.orderList.components.OrderInfo.createTime':
    'Create Time',
  'pages-pool-member.order.orderList.components.OrderInfo.remark': 'Remark',

  /** pages-pool-member order item */
  'pages-pool-member.order.orderList.components.OrderItem.orderItemInfo':
    'Order Item Info',
  'pages-pool-member.order.orderList.components.OrderItem.goodsName':
    'Goods Name',
  'pages-pool-member.order.orderList.components.OrderItem.goodsDescription':
    'Goods Description',
  'pages-pool-member.order.orderList.components.OrderItem.noDescription':
    'No Description',
  'pages-pool-member.order.orderList.components.OrderItem.unitPrice':
    'Unit Price',
  'pages-pool-member.order.orderList.components.OrderItem.purchaseQuantity':
    'Purchase Quantity',
  'pages-pool-member.order.orderList.components.OrderItem.actualPayment':
    'Actual Payment',
  'pages-pool-member.order.orderList.components.OrderItem.swimmerName':
    'Swimmer Name',
  'pages-pool-member.order.orderList.components.OrderItem.emergencyContact':
    'Emergency Contact',
  'pages-pool-member.order.orderList.components.OrderItem.emergencyPhone':
    'Emergency Phone',

  /** pages-pool-member pay order list */
  'pages-pool-member.order.payOrderList.index.timeRange': 'Time Range',
  'pages-pool-member.order.payOrderList.index.orderId': 'Pay Order ID',
  'pages-pool-member.order.payOrderList.index.paymentTime': 'Payment Time',
  'pages-pool-member.order.payOrderList.index.payStatus': 'Payment Status',
  'pages-pool-member.order.payOrderList.index.orderSource': 'Order Source',
  'pages-pool-member.order.payOrderList.index.relatedGoods': 'Related Goods',
  'pages-pool-member.order.payOrderList.index.paymentType': 'Payment Type',
  'pages-pool-member.order.payOrderList.index.paymentAmount': 'Payment Amount',
  'pages-pool-member.order.payOrderList.index.member': 'Member',
  'pages-pool-member.order.payOrderList.index.createTime': 'Create Time',
  'pages-pool-member.order.payOrderList.index.details': 'Details',
  'pages-pool-member.order.payOrderList.index.exportDetails': 'Export Details',

  /** pages-pool-member pay order detail */
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payOrderDetails':
    'Pay Order Details',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.basicInfoTitle':
    'Basic Information',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.orderId':
    'Order ID',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.orderNo':
    'Order Number',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.wxPayNo':
    'WeChat Pay Number',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.createTime':
    'Create Time',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.updateTime':
    'Update Time',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.remark':
    'Remark',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.paymentInfoTitle':
    'Payment Information',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.totalPrice':
    'Total Amount',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payPrice':
    'Paid Amount',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payTypeName':
    'Payment Type',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payStatusName':
    'Payment Status',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.description':
    'Description',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payTime':
    'Payment Time',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.orderType':
    'Order Type',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.memberName':
    'Member Name',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.payChannel':
    'Payment Channel',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.refundInfoTitle':
    'Refund Information',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.refundFee':
    'Refund Amount',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.refundTime':
    'Refund Time',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.refundReason':
    'Refund Reason',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.goodsInfoTitle':
    'Goods Information',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.goodsType':
    'Goods Type',
  'pages-pool-member.order.payOrderList.components.PayOrderInfo.goodsName':
    'Goods Name',

  /** pages-pool-member member list */
  'pages-pool-member.member.memberList.index.confirmEnable': 'Confirm Enable',
  'pages-pool-member.member.memberList.index.confirmDisable': 'Confirm Disable',
  'pages-pool-member.member.memberList.index.okText': 'OK',
  'pages-pool-member.member.memberList.index.cancelText': 'Cancel',
  'pages-pool-member.member.memberList.index.enableSuccess':
    'Enabled Successfully',
  'pages-pool-member.member.memberList.index.enableFailed': 'Enable Failed',
  'pages-pool-member.member.memberList.index.disableSuccess':
    'Disabled Successfully',
  'pages-pool-member.member.memberList.index.disableFailed': 'Disable Failed',
  'pages-pool-member.member.memberList.index.nickname': 'Nickname',
  'pages-pool-member.member.memberList.index.wechatId': 'WeChat ID',
  'pages-pool-member.member.memberList.index.status': 'Status',
  'pages-pool-member.member.memberList.index.statusEnabled': 'Enabled',
  'pages-pool-member.member.memberList.index.statusDisabled': 'Disabled',
  'pages-pool-member.member.memberList.index.lastLoginTime': 'Last Login Time',
  'pages-pool-member.member.memberList.index.createTime': 'Create Time',
  'pages-pool-member.member.memberList.index.action': 'Action',
  'pages-pool-member.member.memberList.index.edit': 'Edit',
  'pages-pool-member.member.memberList.index.detail': 'Detail',
  'pages-pool-member.member.memberList.index.balance': 'Balance',
  'pages-pool-member.member.memberList.index.recharge': 'Recharge',
  'pages-pool-member.member.memberList.index.rechargeTitle': 'Member Recharge',
  'pages-pool-member.member.memberList.index.rechargeAmount': 'Amount',
  'pages-pool-member.member.memberList.index.rechargeAmountRequired':
    'Please enter the amount',
  'pages-pool-member.member.memberList.index.rechargeReason': 'Reason',
  'pages-pool-member.member.memberList.index.rechargePaySet': 'Wallet type',
  'pages-pool-member.member.memberList.index.rechargePaySetPlaceholder':
    'Optional, e.g. benefit card',
  'pages-pool-member.member.memberList.index.rechargeSuccess':
    'Recharge successful',
  'pages-pool-member.member.memberList.index.enable': 'Enable',
  'pages-pool-member.member.memberList.index.disable': 'Disable',
  'pages-pool-member.member.memberList.index.memberBalance': 'Member Balance',
  'pages-pool-member.member.memberList.index.currentBalance': 'Current Balance',

  'pages-pool-member.member.memberList.components.CreateMember.addMember':
    'Add Member',
  'pages-pool-member.member.memberList.components.CreateMember.createSuccess':
    'Created Successfully',
  'pages-pool-member.member.memberList.components.CreateMember.memberName':
    'Member Name',
  'pages-pool-member.member.memberList.components.CreateMember.inputMemberName':
    'Please enter member name',
  'pages-pool-member.member.memberList.components.CreateMember.memberPhone':
    'Member Phone',
  'pages-pool-member.member.memberList.components.CreateMember.inputMemberPhone':
    'Please enter member phone',
  'pages-pool-member.member.memberList.components.CreateMember.phoneFormatError':
    'Invalid phone format',
  'pages-pool-member.member.memberList.components.CreateMember.memberIdCard':
    'ID Card',
  'pages-pool-member.member.memberList.components.CreateMember.inputMemberIdCard':
    'Please enter ID card',
  'pages-pool-member.member.memberList.components.CreateMember.idCardFormatError':
    'Invalid ID card format',
  'pages-pool-member.member.memberList.components.CreateMember.gender':
    'Gender',
  'pages-pool-member.member.memberList.components.CreateMember.selectGender':
    'Please select gender',
  'pages-pool-member.member.memberList.components.CreateMember.male': 'Male',
  'pages-pool-member.member.memberList.components.CreateMember.female':
    'Female',
  'pages-pool-member.member.memberList.components.CreateMember.unknown':
    'Unknown',

  'pages-pool-member.member.memberList.components.UpdateMember.editMemberInfo':
    'Edit Member Info',
  'pages-pool-member.member.memberList.components.UpdateMember.nickname':
    'Nickname',
  'pages-pool-member.member.memberList.components.UpdateMember.inputNickname':
    'Please enter nickname',
  'pages-pool-member.member.memberList.components.UpdateMember.name': 'Name',
  'pages-pool-member.member.memberList.components.UpdateMember.inputName':
    'Please enter name',
  'pages-pool-member.member.memberList.components.UpdateMember.phone': 'Phone',
  'pages-pool-member.member.memberList.components.UpdateMember.inputPhone':
    'Please enter phone',
  'pages-pool-member.member.memberList.components.UpdateMember.idCard':
    'ID Card',
  'pages-pool-member.member.memberList.components.UpdateMember.inputIdCard':
    'Please enter ID card',
  'pages-pool-member.member.memberList.components.UpdateMember.birthday':
    'Birthday',
  'pages-pool-member.member.memberList.components.UpdateMember.selectBirthday':
    'Please select birthday',
  'pages-pool-member.member.memberList.components.UpdateMember.address':
    'Address',
  'pages-pool-member.member.memberList.components.UpdateMember.inputAddress':
    'Please enter address',
  'pages-pool-member.member.memberList.components.UpdateMember.profile':
    'Profile',
  'pages-pool-member.member.memberList.components.UpdateMember.inputProfile':
    'Please enter profile',

  'pages-pool-member.member.memberList.components.MemberInfo.memberDetail':
    'Member Detail',
  'pages-pool-member.member.memberList.components.MemberInfo.avatar': 'Avatar',
  'pages-pool-member.member.memberList.components.MemberInfo.username':
    'Username',
  'pages-pool-member.member.memberList.components.MemberInfo.no': '-',
  'pages-pool-member.member.memberList.components.MemberInfo.nickname':
    'Nickname',
  'pages-pool-member.member.memberList.components.MemberInfo.realName':
    'Real Name',
  'pages-pool-member.member.memberList.components.MemberInfo.phone': 'Phone',
  'pages-pool-member.member.memberList.components.MemberInfo.gender': 'Gender',
  'pages-pool-member.member.memberList.components.MemberInfo.birthday':
    'Birthday',
  'pages-pool-member.member.memberList.components.MemberInfo.notSet': 'Not Set',
  'pages-pool-member.member.memberList.components.MemberInfo.idCard': 'ID Card',
  'pages-pool-member.member.memberList.components.MemberInfo.certificateType':
    'Certificate Type',
  'pages-pool-member.member.memberList.components.MemberInfo.idCardType':
    'ID Card',
  'pages-pool-member.member.memberList.components.MemberInfo.balance':
    'Balance',
  'pages-pool-member.member.memberList.components.MemberInfo.points': 'Points',
  'pages-pool-member.member.memberList.components.MemberInfo.bindBracelet':
    'Bound Bracelet',
  'pages-pool-member.member.memberList.components.MemberInfo.notBind':
    'Not Bound',
  'pages-pool-member.member.memberList.components.MemberInfo.namedStatus':
    'Verification Status',
  'pages-pool-member.member.memberList.components.MemberInfo.named': 'Verified',
  'pages-pool-member.member.memberList.components.MemberInfo.unnamed':
    'Unverified',
  'pages-pool-member.member.memberList.components.MemberInfo.ranking':
    'Ranking',
  'pages-pool-member.member.memberList.components.MemberInfo.totalEntryCount':
    'Total Entry Count',
  'pages-pool-member.member.memberList.components.MemberInfo.registerTime':
    'Register Time',
  'pages-pool-member.member.memberList.components.MemberInfo.lastPurchaseTime':
    'Last Purchase Time',
  'pages-pool-member.member.memberList.components.MemberInfo.lastEntryTime':
    'Last Entry Time',
  'pages-pool-member.member.memberList.components.MemberInfo.createTime':
    'Create Time',
  'pages-pool-member.member.memberList.components.MemberInfo.updateTime':
    'Update Time',
  'pages-pool-member.member.memberList.components.MemberInfo.address':
    'Address',
  'pages-pool-member.member.memberList.components.MemberInfo.profile':
    'Profile',

  /** pages-pool-member swimmer list */
  'pages-pool-member.member.swimmerList.index.name': 'Name',
  'pages-pool-member.member.swimmerList.index.gender': 'Gender',
  'pages-pool-member.member.swimmerList.index.isTrainStudent': 'Trainee',
  'pages-pool-member.member.swimmerList.index.yes': 'Yes',
  'pages-pool-member.member.swimmerList.index.no': 'No',
  'pages-pool-member.member.swimmerList.index.faceImg': 'Face Image',
  'pages-pool-member.member.swimmerList.index.phone': 'Phone',
  'pages-pool-member.member.swimmerList.index.idCard': 'ID Card',
  'pages-pool-member.member.swimmerList.index.braceletNo': 'Bracelet No.',
  'pages-pool-member.member.swimmerList.index.address': 'Address',
  'pages-pool-member.member.swimmerList.index.emergencyContactName':
    'Emergency Contact Name',
  'pages-pool-member.member.swimmerList.index.emergencyContactPhone':
    'Emergency Contact Phone',
  'pages-pool-member.member.swimmerList.index.status': 'Status',
  'pages-pool-member.member.swimmerList.index.statusEnabled': 'Enabled',
  'pages-pool-member.member.swimmerList.index.statusDisabled': 'Disabled',
  'pages-pool-member.member.swimmerList.index.memberName': 'Member Name',
  'pages-pool-member.member.swimmerList.index.createTime': 'Create Time',
  'pages-pool-member.member.swimmerList.index.orderTime': 'Expire Time',
  'pages-pool-member.member.swimmerList.index.vipName': 'Membership Card Name',
  'pages-pool-member.member.swimmerList.index.vipPhone': 'Membership Phone',
  'pages-pool-member.member.swimmerList.index.info': 'Detail',
  'pages-pool-member.member.swimmerList.index.viewPhoto': 'View Photo',
  'pages-pool-member.member.swimmerList.index.confirmDelete':
    'Confirm deleting this swimmer?',
  'pages-pool-member.member.swimmerList.index.deleteSuccess':
    'Deleted Successfully',
  'pages-pool-member.member.swimmerList.index.delete': 'Delete',
  'pages-pool-member.member.swimmerList.index.confirmEnable':
    'Confirm enabling this swimmer?',
  'pages-pool-member.member.swimmerList.index.enableSuccess':
    'Enabled Successfully',
  'pages-pool-member.member.swimmerList.index.enable': 'Enable',
  'pages-pool-member.member.swimmerList.index.confirmDisable':
    'Confirm disabling this swimmer?',
  'pages-pool-member.member.swimmerList.index.disableSuccess':
    'Disabled Successfully',
  'pages-pool-member.member.swimmerList.index.disable': 'Disable',

  'pages-pool-member.member.swimmerList.components.CreateSwimmer.memberPhone':
    'Member Phone',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.correctMemberPhone':
    'Please enter a valid member phone',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.memberNotFound':
    'Member not found',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.addSwimmer':
    'Add Swimmer',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.createSuccess':
    'Created Successfully',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.search':
    'Search',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.memberNameLabel':
    'Member Name',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.memberNicknameLabel':
    'Member Nickname',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.memberPhoneLabel':
    'Member Phone',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.swimmerName':
    'Swimmer Name',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.inputSwimmerName':
    'Please enter swimmer name',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.swimmerPhone':
    'Swimmer Phone',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.inputSwimmerPhone':
    'Please enter swimmer phone',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.swimmerIdCard':
    'Swimmer ID Card',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.inputSwimmerIdCard':
    'Please enter swimmer ID card',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.emergencyContactName':
    'Emergency Contact Name',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.inputEmergencyContactName':
    'Please enter emergency contact name',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.emergencyContactPhone':
    'Emergency Contact Phone',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.inputEmergencyContactPhone':
    'Please enter emergency contact phone',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.status':
    'Status',
  'pages-pool-member.member.swimmerList.components.CreateSwimmer.selectStatus':
    'Please select status',

  'pages-pool-member.member.swimmerList.components.SwimmerInfo.name': 'Name',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.braceletNo':
    'Bracelet No.',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.gender':
    'Gender',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.phone': 'Phone',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.idCard':
    'ID Card',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.address':
    'Address',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.member':
    'Member',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.swimmerType':
    'Swimmer Type',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.isTrainStudent':
    'Trainee',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.emergencyContact':
    'Emergency Contact',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.emergencyContactPhone':
    'Emergency Contact Phone',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.status':
    'Status',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.statusEnabled':
    'Enabled',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.statusDisabled':
    'Disabled',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.faceImage':
    'Face Image',
  'pages-pool-member.member.swimmerList.components.SwimmerInfo.swimmerDetail':
    'Swimmer Detail',

  'pages-pool-member.member.swimmerList.components.UpdateSwimmer.faceImageInfo':
    'Upload face image (jpg/png, clear front face recommended)',
  'pages-pool-member.member.swimmerList.components.UpdateSwimmer.editSuccess':
    'Updated Successfully',

  /** pages-pool-member appointment / verification */
  'pages-pool-member.appoint.buyNow.temp': 'Buy now (guest)',
  'pages-pool-member.appoint.buyNow.vip': 'Buy now (member)',
  'pages-pool-member.appoint.appointUse': 'Book usage',
  'pages-pool-member.appoint.enterNow': 'Enter now',
  'pages-pool-member.appoint.id': 'Appointment ID',
  'pages-pool-member.appoint.swimmer': 'Swimmer',
  'pages-pool-member.appoint.time': 'Appointment time',
  'pages-pool-member.appoint.timeRange': 'Time slot',
  'pages-pool-member.appoint.from': 'Source',
  'pages-pool-member.appoint.referGoods': 'Related goods',
  'pages-pool-member.appoint.referOrder': 'Related order',
  'pages-pool-member.appoint.status': 'Status',
  'pages-pool-member.appoint.member': 'Member',
  'pages-pool-member.appoint.loginTime': 'Registered at',
  'pages-pool-member.appoint.enter': 'Enter',
  'pages-pool-member.appoint.leave': 'Leave',
  'pages-pool-member.appoint.cancel': 'Cancel',
  'pages-pool-member.appoint.name': 'Name',
  'pages-pool-member.appoint.sex': 'Gender',
  'pages-pool-member.appoint.emergencyContact': 'Emergency contact',
  'pages-pool-member.appoint.addCustomer': 'Please add guest',
  'pages-pool-member.appoint.duplicateSwimmer':
    'This swimmer is already selected',
  'pages-pool-member.appoint.buyNow': 'Buy now',
  'pages-pool-member.appoint.applyNow': 'Pay now',
  'pages-pool-member.appoint.bingRing': 'Bind bracelet',
  'pages-pool-member.appoint.rightId': 'Bracelet ID',
  'pages-pool-member.appoint.batchAddFailed': 'Batch add failed',
};
